<template>
  <v-card :class="cardClass" :style="cardStyle">
    <v-row desnse no-gutters justify="center" align="center" v-if="title">
      <v-col :cols="secondValue !== null && secondValue !== undefined ? 6 : 12" class="pt-2 px-2 pb-0">
        <div :class="titleClass + ' text-no-wrap text-truncate'">
          <v-tooltip open-delay="500" bottom v-if="tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" left v-if="icon" :color="iconColor">{{ icon }}</v-icon>
            </template>
            <div v-html="tooltip"></div>
          </v-tooltip>
          <v-icon left v-else-if="icon" :color="iconColor">{{ icon }}</v-icon>
          {{ title }}
        </div>
      </v-col>
      <v-col v-if="secondValue !== null && secondValue !== undefined" cols="6" class="pt-2 px-2 pb-0">
        <div :class="secondTitleClass + ' text-no-wrap text-truncate'">
          {{ secondTitle }}
        </div>
      </v-col>
    </v-row>
    <v-card-text class="pt-0 pb-2">
      <v-row dense no-gutters justify="center" align="center">
        <v-col
          v-if="value !== null && value !== undefined"
          :cols="secondValue !== null && secondValue !== undefined ? 6 : 12"
        >
          <div :class="valueClass + ' text-no-wrap text-truncate'">{{ value }}</div>
        </v-col>
        <v-col v-else :class="valueClass" cols="12">
          <v-icon large center class="empty-icon"> fa-regular fa-empty-set </v-icon>
        </v-col>
        <v-col v-if="secondValue !== null && secondValue !== undefined" cols="6">
          <div :class="secondValueClass + ' text-no-wrap text-truncate'">{{ secondValue }}</div>
        </v-col>
        <v-col :cols="secondValue !== null && secondValue !== undefined ? 6 : 12">
          <slot name="subtitle"></slot>
          <div v-if="!!!this.$slots.subtitle" :class="subtitleClass">{{ subtitle }}</div>
        </v-col>
        <v-col v-if="secondValue !== null && secondValue !== undefined" cols="6">
          <slot name="secondSubtitle"></slot>
          <div v-if="!!!this.$slots.secondSubtitle" :class="secondSubtitleClass">{{ secondSubtitle }}</div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'RiskAnalysisSummaryCard',
  props: {
    value: String,
    valueClass: String,
    icon: String,
    iconColor: String,
    title: String,
    titleClass: String,
    subtitle: String,
    subtitleClass: String,
    tooltip: String,
    secondValue: String,
    secondValueClass: String,
    secondTitle: String,
    secondTitleClass: String,
    secondSubtitle: String,
    secondSubtitleClass: String,
    secondTooltip: String,
    cardClass: String,
    cardStyle: String
  }
}
</script>
<style lang="scss" scoped>
.v-tooltip__content {
  background-color: #ffffff;
  color: var(--v-primary-base);
  opacity: 0.9 !important;
  border: 1px solid var(--v-primary-base) !important;
  max-width: 400px;
}
</style>
